import { axios } from '@/utils/request'

export default {
    create(input){
        return axios.post('/api/services/app/SchoolRoom/Create',input)
    },
    update(input){
        return axios.put('/api/services/app/SchoolRoom/Update',input)
    },
    delete(id){
        return axios.delete('/api/services/app/SchoolRoom/Delete?Id='+id)
    },
    get(id){
        return axios.get('/api/services/app/SchoolRoom/Get?Id='+id)
    },
    getAll(page){
        return axios.get('/api/services/app/SchoolRoom/GetAll',{params:page})
    },
    getSchools(){
        return axios.get('/api/services/app/SchoolRoom/GetSchools')
    }
}